<script setup lang="ts">
import { RouterView } from 'vue-router';
import AppToast from '@/components/ui/AppToast.vue';
import SessionExpiryAlert from '@/components/ui/session-expiry-alert.vue';
</script>

<template>
  <RouterView />
  <!-- One bottom-right stack shared by both: a toast must never end up covering the
       "Stay signed in" button. -->
  <div
    class="pointer-events-none fixed bottom-4 right-4 z-50 flex flex-col items-end gap-2"
  >
    <SessionExpiryAlert />
    <AppToast />
  </div>
</template>
